import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const SP_API_BASE = `${BACKEND_URL}/api/sales-portal`;
export const SP_TOKEN_KEY = "sp_access_token";

export const spApi = axios.create({
  baseURL: SP_API_BASE,
  withCredentials: false,
});

const bootToken = typeof window !== "undefined" ? localStorage.getItem(SP_TOKEN_KEY) : null;
if (bootToken) spApi.defaults.headers.common["Authorization"] = `Bearer ${bootToken}`;

export function setSPToken(token) {
  if (token) {
    localStorage.setItem(SP_TOKEN_KEY, token);
    spApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem(SP_TOKEN_KEY);
    delete spApi.defaults.headers.common["Authorization"];
  }
}

export function spFormatError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return err?.message || "Something went wrong";
}

export const SP_STATUSES = [
  { value: "new", label: "New", tone: "sky" },
  { value: "contacted", label: "Contacted", tone: "amber" },
  { value: "in_progress", label: "In progress", tone: "indigo" },
  { value: "qualified", label: "Qualified", tone: "emerald" },
  { value: "closed", label: "Closed", tone: "violet" },
  { value: "lost", label: "Lost", tone: "rose" },
];

export function labelFor(status) {
  return SP_STATUSES.find((s) => s.value === status)?.label || status;
}
